import { gql } from 'graphql-tag'

export const campaignPageQuery = gql`
  query CampaignPageQuery($stationId: ID!) {
    campaigns(stationId: $stationId) {
      id
      name
      description
      startTime
      endTime
      offers {
        buy {
          productGroups {
            quantity
            products
          }
        }
        get {
          totalPrice
          productGroups {
            quantity
            discountAmount
            discountPercent
            priceAmount
            products
          }
        }
      }
    }
  }
`
